import { useCallback, useMemo } from 'react'
import { GridCellParams, GridRowClassNameParams } from '@mui/x-data-grid-pro'

import { useBulkActionContext } from '../atoms'
import type { GridComponentProps } from '../typings'
import { cellErrorClass, rowErrorClass } from '../StyledXGrid.styled'

export function useBulkActionErrors(props: GridComponentProps) {
  const {
    columnVisibilityModel: vis = {},
    getCellClassName: getCellClassNameFromProps,
    getRowClassName: getRowClassNameFromProps,
  } = props

  const {
    state: { activeBulkAction, errors },
  } = useBulkActionContext()
  //to-do return string of the name of the class
  const getRowClassName = useCallback(
    (params: GridRowClassNameParams) =>
      getRowClassNameFromProps
        ? getRowClassNameFromProps(params)
        : errors.has(params.id)
          ? rowErrorClass
          : '',
    [errors, getRowClassNameFromProps],
  )

  const getCellClassName = useCallback(
    (params: GridCellParams) =>
      getCellClassNameFromProps
        ? getCellClassNameFromProps(params)
        : params.field === '__check__' && errors.has(params.id)
          ? cellErrorClass
          : '',
    [errors, getCellClassNameFromProps],
  )

  const columnVisibilityModel = useMemo(
    () => ({
      ...vis,
      __bulkErrors__:
        activeBulkAction !== undefined &&
        activeBulkAction !== 'delete' &&
        errors.size > 0,
    }),
    [activeBulkAction, vis, errors.size],
  )

  return {
    getRowClassName,
    getCellClassName,
    columnVisibilityModel,
  }
}
